/* eslint-disable max-lines-per-function */
import { useIsMobile } from '@/hooks';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

// oxlint-disable-next-line max-lines-per-function
export function ConfirmDialog({
  isOpen,
  setIsOpen,
  isSubmitting,
}: {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  isSubmitting: boolean;
}) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={setIsOpen}>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.dialogTitle',
              )}
            </DrawerTitle>
          </DrawerHeader>
          <DrawerBody>
            <DrawerDescription>
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.dialogSubTitle',
              )}
            </DrawerDescription>
            <DrawerFooter>
              <Button form="createRotationsplanForm" disabled={isSubmitting}>
                {t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.confirm',
                )}
              </Button>
              <Button variant="secondary-blue" onClick={() => setIsOpen(false)}>
                {t(
                  'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.cancel',
                )}
              </Button>
            </DrawerFooter>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.dialogTitle',
            )}
          </DialogTitle>
          <DialogDescription>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.dialogSubTitle',
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter variant="default">
          <Button variant="secondary-blue" onClick={() => setIsOpen(false)}>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.cancel',
            )}
          </Button>
          <Button form="createRotationsplanForm" disabled={isSubmitting}>
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.planExistiert.confirm',
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
